module.exports = __webpack_public_path__ + "img/share_txt_gq.cd879700.png";